import moment from 'moment'

export function durationInMinutes(duration) {
    return moment.duration(duration).asMinutes()
}

export default (date, duration) => {
    if (date === undefined || duration === undefined) return undefined
    let durationMinutes = durationInMinutes(duration)
    let flightDateFormatted = moment(date).add(durationMinutes, "minutes").format("HH:mm")
    return durationMinutes >= 1440
        ? `+ ${flightDateFormatted}`
        : flightDateFormatted
}


// WEBPACK FOOTER //
// ./src/screens/flights/utils/formatFlightDate.js